//先清除cookie
function clearAllCookies() {
	var keys = document.cookie.match(/[^ =;]+(?==)/g)
	if (keys) {
		for (var i = keys.length; i--;) {
			document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
			document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();
			document.cookie = keys[i] + '=0;path=/;domain=ningmengyun.com;expires=' + new Date(0).toUTCString();
		}
	}
}
clearAllCookies();

import Vue from 'vue'

Vue.config.errorHandler = function(err, vm, info) {
	alert(err.message);
	console.error(err);
}

import _ from 'lodash'
Vue.use(_)

import App from './App.vue'
import './registerServiceWorker'
// import router from './router'
import store from './store'

// URL包装
import './scripts/services.js'

//F7 Vue版本
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
Framework7.use(Framework7Vue)

// 公用方法
import methods from './scripts/methods.js'
Vue.use(methods);


// import  VConsole  from  'vconsole';
// let vConsole = new VConsole();

// 路由器
import router from './scripts/router.js'
Vue.use(router);

//图标及样式
import 'framework7-icons';
import 'framework7/css/framework7.bundle.min.css';

//主题样式 :root,变量
import './content/theme.less';
//framework7默认样式更改
import './content/f7.less';
//html标签的公共样式
import './content/html.less';
//字体相关的class
import './content/font.less';
//设置 color，background-color,border-color 的class
import './content/color.less';
//流式布局相关class
import './content/flex.less';
//margin相关class
import './content/margin.less';
//padding相关样式
import './content/padding.less';
//杂七杂八的样式
import './content/misc.less';


import LemonUI from './components/commons/index.js';
Vue.use(LemonUI)

// 过滤器
import filters from './scripts/filters.js'
Vue.use(filters);

Vue.config.productionTip = false

// 检查是否存在 #app 元素  
new Vue({
	el: "#app",
	// router,
	store,
	render: h => h(App)
})

window.addEventListener('touchmove', function() {
	if (document.hasFocus) {
		document.activeElement.blur();
	}
});
